import { createAsyncThunk } from "@reduxjs/toolkit";
import { invitesAPI } from "../api";
import { thunkHandlers } from "../../../store/thunkHandlers";
import { setMessage } from "../../messages/model/slice";
import { MESSAGE_SEVERITY } from "../../../utils/const";
import {IAcceptInviteData, ICreateInviteData} from "../../../models/IInvites";

export const fetchListInvites = createAsyncThunk(
    "invites/list",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            return await invitesAPI.list();
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);

export const fetchCreateInvite = createAsyncThunk(
    "invites/create",
    async (data: ICreateInviteData, { dispatch, rejectWithValue }) => {
        try {
            const result = await invitesAPI.create(data);
            dispatch(
                setMessage({
                    severity: MESSAGE_SEVERITY.success,
                    text: "Приглашение создано. Ссылка отправлена сотруднику на email.",
                }),
            );
            // После успеха перезагружаем список, чтобы новый инвайт появился.
            dispatch(fetchListInvites());
            return result;
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);

export const fetchRevokeInvite = createAsyncThunk(
    "invites/revoke",
    async (id: string, { dispatch, rejectWithValue }) => {
        try {
            const result = await invitesAPI.revoke(id);
            dispatch(
                setMessage({
                    severity: MESSAGE_SEVERITY.success,
                    text: "Приглашение отозвано.",
                }),
            );
            return result;
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);

export const fetchResendInvite = createAsyncThunk(
    "invites/resend",
    async (id: string, { dispatch, rejectWithValue }) => {
        try {
            // Возвращает ICreateInviteResponse: новый raw_token + invite_url.
            const result = await invitesAPI.resend(id);
            dispatch(
                setMessage({
                    severity: MESSAGE_SEVERITY.success,
                    text: "Ссылка перевыпущена и отправлена повторно. Предыдущая ссылка больше не работает.",
                }),
            );
            // Список изменился (новый expires_at, токен) — перезагружаем, чтобы
            // строка обновилась. Сам результат уйдёт в lastCreated (см. slice),
            // открыв модалку "ссылка готова — скопировать".
            dispatch(fetchListInvites());
            return result;
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);

export const fetchInviteInfo = createAsyncThunk(
    "invites/info",
    async (token: string, { dispatch, rejectWithValue }) => {
        try {
            return await invitesAPI.info(token);
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);

/**
 * Принятие инвайта. По сути — отдельный вид fetchLogin: после успешного
 * accept выставляется access_token и юзер дальше работает как залогиненный.
 */
export const fetchAcceptInvite = createAsyncThunk(
    "invites/accept",
    async (data: IAcceptInviteData, { dispatch, rejectWithValue }) => {
        try {
            const { access_token } = await invitesAPI.accept(data);
            if (access_token) {
                localStorage.setItem("access_token", access_token);
            }
            dispatch(
                setMessage({
                    severity: MESSAGE_SEVERITY.success,
                    text: "Регистрация прошла успешно!",
                }),
            );
            return access_token;
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);